"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _fiveLayerDonut = require("./five-layer-donut");

var _fiveLayerDonut2 = _interopRequireDefault(_fiveLayerDonut);

var _fourLayerDonut = require("./four-layer-donut");

var _fourLayerDonut2 = _interopRequireDefault(_fourLayerDonut);

var _threeLayerDonut = require("./three-layer-donut");

var _threeLayerDonut2 = _interopRequireDefault(_threeLayerDonut);

var _twoLayerDonut = require("./two-layer-donut");

var _twoLayerDonut2 = _interopRequireDefault(_twoLayerDonut);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Donut = function Donut(props) {
  var doughnutparts = props.doughnutparts;


  switch (doughnutparts) {
    case 5:
      return _react2.default.createElement(_fiveLayerDonut2.default, {
        toggleEquality: props.hasEqualParts,
        chartSize: props.doughnutsize,
        colorobject: props.doughnutcolors,
        valuesobject: props.doughnutvalues });
    case 4:
      return _react2.default.createElement(_fourLayerDonut2.default, {
        toggleEquality: props.hasEqualParts,
        chartSize: props.doughnutsize,
        colorobject: props.doughnutcolors,
        valuesobject: props.doughnutvalues });
    case 3:
      return _react2.default.createElement(_threeLayerDonut2.default, {
        toggleEquality: props.hasEqualParts,
        chartSize: props.doughnutsize,
        colorobject: props.doughnutcolors,
        valuesobject: props.doughnutvalues });
    case 2:
      return _react2.default.createElement(_twoLayerDonut2.default, {
        toggleEquality: props.hasEqualParts,
        chartSize: props.doughnutsize,
        colorobject: props.doughnutcolors,
        valuesobject: props.doughnutvalues });
    case 1:
      return _react2.default.createElement(_twoLayerDonut2.default, {
        toggleEquality: props.hasEqualParts,
        chartSize: props.doughnutsize,
        colorobject: props.doughnutcolors,
        valuesobject: props.doughnutvalues });
    default:
      return _react2.default.createElement(_threeLayerDonut2.default, {
        toggleEquality: props.hasEqualParts,
        chartSize: props.doughnutsize,
        colorobject: {
          c1: "#D1A917",
          c2: "#2C9DC2",
          c3: "#D12A6A"
        },
        valuesobject: {
          p1: 35,
          p2: 40,
          p3: 25
        } });
  }
};

exports.default = Donut;